module.exports = __webpack_public_path__ + "static/media/india-background.5fe6179c.jpg";